import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { DailyPluckingAverageAnalaysisReport } from './Pages/listing';

export const DailyPluckingAverageAnalaysisRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={DailyPluckingAverageAnalaysisReport} />
    </Fragment>
)